import { useSearchParams } from 'react-router-dom';

import { PageHeader } from '@/shared/ui/PageHeader';
import { classeDaAba, trilhoDeAbas } from '@/shared/ui/tabStyles';

import { LogsAccessTab } from './LogsAccessTab';
import { LogsAuditTab } from './LogsAuditTab';
import { LogsTasksTab } from './LogsTasksTab';

/**
 * Logs: o "Gerenciamento de logs" do OnPoint (LOG-001), com as abas Auditoria,
 * Acessos e Tarefas.
 *
 * No OnPoint a tela fica fora dos menus e nenhum dos perfis lidos a abre (LOG-002); a
 * seguradora ainda nao disse se a usa (K3). Aqui ela existe no grupo Administracao,
 * protegida por auditoria.log.view, e a permissao no perfil decide quem a ve (ADR
 * 0119). Os logs sao da seguradora: a corretora nao ve o item nem as rotas.
 *
 * A aba aberta fica no endereco (`?aba=`), para que a aba Auditoria de Configuracoes
 * e outras telas levem direto a ela.
 */

type Aba = 'auditoria' | 'acessos' | 'tarefas';

const abas: { chave: Aba; rotulo: string }[] = [
  { chave: 'auditoria', rotulo: 'Auditoria' },
  { chave: 'acessos', rotulo: 'Acessos' },
  { chave: 'tarefas', rotulo: 'Tarefas' },
];

function abaDoEndereco(valor: string | null): Aba {
  return abas.some((item) => item.chave === valor) ? (valor as Aba) : 'auditoria';
}

export function LogsPage() {
  const [busca, setBusca] = useSearchParams();
  const aba = abaDoEndereco(busca.get('aba'));

  const abrir = (chave: Aba) => {
    const proxima = new URLSearchParams(busca);
    if (chave === 'auditoria') proxima.delete('aba');
    else proxima.set('aba', chave);
    setBusca(proxima, { replace: true });
  };

  return (
    <div className="flex flex-col gap-5">
      <PageHeader
        title="Logs"
        description="Trilha de auditoria, acessos a plataforma e rotinas automaticas da empresa."
      />

      <div role="tablist" aria-label="Logs" className={trilhoDeAbas}>
        {abas.map((item) => (
          <button
            key={item.chave}
            type="button"
            role="tab"
            id={`aba-logs-${item.chave}`}
            aria-selected={aba === item.chave}
            aria-controls={`painel-logs-${item.chave}`}
            onClick={() => abrir(item.chave)}
            className={aba === item.chave ? classeDaAba(true) : classeDaAba(false)}
          >
            {item.rotulo}
          </button>
        ))}
      </div>

      <div
        role="tabpanel"
        id={`painel-logs-${aba}`}
        aria-labelledby={`aba-logs-${aba}`}
      >
        {aba === 'auditoria' ? <LogsAuditTab /> : null}
        {aba === 'acessos' ? <LogsAccessTab /> : null}
        {aba === 'tarefas' ? <LogsTasksTab /> : null}
      </div>
    </div>
  );
}
